import { createFileRoute } from '@tanstack/react-router'
import CallSectionTime from '@/components/reports-route/call/call-section-time'
import CallChartHours from '@/components/reports-route/call/call-chart-hours'
import CallChartDays from '@/components/reports-route/call/call-chart-days'
import CallChartMonths from '@/components/reports-route/call/call-chart-months'
import { Layout } from '@/components/custom/layout'
import { useState } from 'react'
import { subDays } from 'date-fns'
import { useQuery } from '@tanstack/react-query'
import { throwException } from '@/exceptions/throw-exception.js'
import {
  reportSummaryCall,
  reportSummaryCallHours,
  reportSummaryCallYears,
} from '@/api/report'
import { format } from 'date-fns'
import QUERY_KEY from '@/constants/use-query-key.js'
import RangeDatePicker from '@/components/custom/range-date-picker'

export const Route = createFileRoute('/_auth/report/call')({
  component: CallReport,
})

function CallReport() {
  const [formFilter, setFormFilter] = useState({
    start_date: subDays(new Date(), '7'),
    end_date: new Date(),
  })

  const fetchDataCall = async () => {
    const payload = {
      from: format(formFilter.start_date, 'yyyy-MM-dd'),
      to: format(formFilter.end_date, 'yyyy-MM-dd'),
    }
    try {
      const resp = await reportSummaryCall({ params: payload })
      return resp.data
    } catch (error) {
      throwException(error)
    }
  }

  const fetchDataCallYear = async () => {
    const payload = {}
    try {
      const resp = await reportSummaryCallYears({ params: payload })
      return resp.data
    } catch (error) {
      throwException(error)
    }
  }

  const fetchDataCallHours = async () => {
    const payload = {
      from: format(formFilter.start_date, 'yyyy-MM-dd'),
      to: format(formFilter.end_date, 'yyyy-MM-dd'),
    }
    try {
      const resp = await reportSummaryCallHours({ params: payload })
      return resp.data
    } catch (error) {
      throwException(error)
    }
  }

  const { isLoading: isLoadingHours, data: queryDataCallHours } = useQuery({
    queryKey: [
      QUERY_KEY.GET_CALL_REPORT_BY_HOUR,
      {
        params: {
          formFilter: formFilter,
        },
      },
    ],
    queryFn: fetchDataCallHours,
  })

  const { isLoading: isLoadingCall, data: queryDataCall } = useQuery({
    queryKey: [
      QUERY_KEY.GET_CALL_REPORT,
      {
        params: {
          formFilter: formFilter,
        },
      },
    ],
    queryFn: fetchDataCall,
  })

  const { isLoading: isLoadingCallYear, data: queryDataCallYear } = useQuery({
    queryKey: [QUERY_KEY.GET_CALL_REPORT_IN_YEAR],
    queryFn: fetchDataCallYear,
  })

  return (
    <Layout.Body>
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-lg font-bold">Báo cáo cuộc gọi</h1>
        <RangeDatePicker
          rangeDate={{
            from: formFilter.start_date,
            to: formFilter.end_date,
          }}
          onChangeRangeDate={(value) => {
            setFormFilter({
              start_date: value.from,
              end_date: value.to,
            })
          }}
        />
      </div>
      <CallSectionTime
        loading={isLoadingCall}
        data={queryDataCall?.generalStatistics}
      />
      <CallChartHours
        formFilter={formFilter}
        loading={isLoadingHours}
        data={queryDataCallHours}
      />
      <div>
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-5">
            <CallChartDays
              formFilter={formFilter}
              loading={isLoadingCall}
              data={queryDataCall?.statisticsByDays}
            />
          </div>
          <div className="col-span-7">
            <CallChartMonths
              formFilter={formFilter}
              loading={isLoadingCallYear}
              data={queryDataCallYear}
            />
          </div>
        </div>
      </div>
    </Layout.Body>
  )
}
